export const APP_TOKEN_KEY = "app-token";
export const APP_USER_KEY = "app-user";
export const APP_USER_VIEW_KEY = "app-user-view";
export const APP_TRANS_DEBUG_KEY = "app-trans-debug";
